import dataEn from "./data-en.json";
import dataCn from "./data-cn.json";

export function getLang() {
  if (typeof window === "undefined") return "en";
  if (window.__LOCALE__) return window.__LOCALE__;
  const host = window.location.hostname.toLowerCase();
  if (host.endsWith(".cn") || host.includes(".cn/")) return "cn";
  return "en";
}

export function getData() {
  return getLang() === "cn" ? dataCn : dataEn;
}

export function getLangSwitchUrl() {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname.toLowerCase();
  if (host.endsWith(".cn")) {
    return "https://selenenext.com" + window.location.pathname;
  }
  return "https://selenenext.cn" + window.location.pathname;
}

export function getLangSwitchLabel() {
  if (typeof window === "undefined") return "中文";
  const host = window.location.hostname.toLowerCase();
  return host.endsWith(".cn") ? "English" : "中文";
}

const ui = {
  en: {
    navFeatures: "Features",
    navUsecases: "Usecases",
    navAbout: "About",
    navContact: "Contact",
    brand: "Selene Next",
    contactTitle: "Contact Us",
    contactDesc: "We look forward to hearing from you.",
    contactEmailLabel: "Email",
    contactWechatLabel: "WeChat ID",
    featuresTitle: "Features",
    usecasesTitle: "Usecases",
    aboutTitle: "About Us",
    aboutWhy: "Why Choose Us?",
    footer: "© 2026 SeleneNext",
  },
  cn: {
    navFeatures: "产品特性",
    navUsecases: "应用场景",
    navAbout: "关于我们",
    navContact: "联系方式",
    brand: "Selene Next",
    contactTitle: "联系我们",
    contactDesc: "期待与您交流。",
    contactEmailLabel: "邮箱",
    contactWechatLabel: "微信号",
    featuresTitle: "产品特性",
    usecasesTitle: "应用场景",
    aboutTitle: "关于我们",
    aboutWhy: "为什么选择我们",
    footer: "© 2026 SeleneNext",
  },
};

export function t(key) {
  const lang = getLang();
  return ui[lang]?.[key] || ui.en[key] || key;
}
